module.exports = __webpack_public_path__ + "static/media/pharma3.80ad58ba.jpg";